module.exports = __webpack_public_path__ + "static/media/turkey.a8b21869.svg";